import { tzAxios } from 'api/axios';
import { OrderSummaryResponse } from 'api/responseTypes';

export const getOrderSummary = async (id: string) =>
  (await tzAxios.get<OrderSummaryResponse>(`/ticket-zone/ticket-orders/summary/${id}`)).data;
